import styled from "styled-components";

export const AboutStyle = styled.section`
`
export const ImageBackStyle = styled.img`
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 800px;
    height: 500px;
    content:url(${require('../../assets/cachorroabout.webp')});
`